import React, { useEffect } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Checkbox,
  ListItemSecondaryAction,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  FormControlLabel,
  Radio,
  DialogTitle,
  TextField,
  Box,
} from "@material-ui/core";
import { Spinner } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";

import { updatePaymentMethods } from "../../../Store/Modules/Store/Actions";
import { ContainerButtonSubmit } from "../styles";
import { ChangeHistoryOutlined } from "@material-ui/icons";
import { InputWithMaskara } from "./inputWithMaskara";

// import { Container } from './styles';

function Payments() {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.store);
  const [openDialogPix, setOpenDialogPix] = React.useState(false);
  const [pixKeyType, setPixKeyType] = React.useState('');
  const [pixKeyValue, setPixkeyValue] = React.useState('');
  const [pixName, setPixName] = React.useState('');

  const handleChange = (e) => {
    setPixkeyValue(e.target.value);
  };

  const pixKeyTypes = [
    {
      description: "phone",
      is_active: false,
    },
    {
      description: "cnpj",
      is_active: false,
    },
    {
      description: "cpf",
      is_active: false,
    },
    {
      description: "email",
      is_active: false,
    },
  ];

  const initialPaymentMethods = [
    { name: "cash", printDescription: "Dinheiro", is_active: true },
    { name: "card", printDescription: "Cartão", is_active: true },
    { name: "pix", printDescription: "Pix", is_active: false },
    { name: "boleto", printDescription: "Boleto", is_active: false },
  ].map((paymentMethod) => {
    const paymentMethodInStore = store.paymentMethods.find(
      (payM) => payM.name === paymentMethod.name
    );
    if (paymentMethodInStore) return paymentMethodInStore;

    return paymentMethod;
  });

  const [paymentMethods, setPaymentMethods] = React.useState(
    initialPaymentMethods
  );

  const handleChangeName = (event) => {
    setPixName(event.target.value);
  };

  const handleOpenDialogPix = () => {
    setOpenDialogPix(!openDialogPix);
  };

  const handleCloseDialogPix = () => {
    const updated = paymentMethods.map((paymentMethod) => {
      if (paymentMethod.name === 'pix') {
        paymentMethod.is_active = false;
      }
      return paymentMethod;
    });
    setPaymentMethods(updated);
    setOpenDialogPix(false);
  };

  const handleToggle = (paymentMethodName) => () => {
    const updated = paymentMethods.map((paymentMethod) => {
      if (paymentMethod.name === paymentMethodName) {
        paymentMethod.is_active = !paymentMethod.is_active;
      }
      return paymentMethod;
    });
    setPaymentMethods(updated);
  };

  const handleSave = () => {
    dispatch({ type: "SET_LOADING" });
    dispatch(updatePaymentMethods(paymentMethods));
  };

  const handleSavePix = async () => {
    const updated = paymentMethods.map((paymentMethod) => {
      if (paymentMethod.name === 'pix') {
        paymentMethod.is_active = true;
        paymentMethod.config = { type: pixKeyType, name: pixName, value: pixKeyValue.replace(/\D/g, '') }
      }
      return paymentMethod;
    });
    setPaymentMethods(updated);
    setOpenDialogPix(false);

  };

  useEffect(() => {
    const pixConfig = store.paymentMethods.find(p => p.name === 'pix')?.config
    console.log('pixconfig', pixConfig)
    if (pixConfig) {
      setPixName(pixConfig.name)
      setPixKeyType(pixConfig.type)
      setPixkeyValue(pixConfig.value)
    }
  }, [store])


  return (
    <>
      <List>
        {paymentMethods.map((paymentMethod) => (
          <ListItem
            key={paymentMethod.name}
            button
            // onClick={handleToggle(paymentMethod.name)}
          >
            {paymentMethod.name === 'pix' ?
              <ListItemText primary={paymentMethod.printDescription} secondary={paymentMethod.config ? `Chave: ${paymentMethod.config.type} - ${paymentMethod.config.value}` : ''} />
              :
              <ListItemText primary={paymentMethod.printDescription} />}

            <ListItemSecondaryAction>
              <Checkbox
                onChange={handleToggle(paymentMethod.name)}
                checked={paymentMethod.is_active}
                onClick={(e) => {
                  if (paymentMethod.name === "pix" && !paymentMethod.is_active)
                    return handleOpenDialogPix();
                }}
              />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
      <hr />
      <ContainerButtonSubmit>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          disabled={!paymentMethods.some((p) => p.is_active)}
        >
          Salvar
        </Button>
      </ContainerButtonSubmit>
      <Dialog open={openDialogPix} >
        <DialogTitle>
          <Typography
            variant="h6"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Escolha o tipo de chave
          </Typography>
        </DialogTitle>
        <DialogContent>
          {pixKeyTypes.map((type, idx) => (
            <FormControlLabel
              style={{
                display: "flex",
                flexDirection: "row",
              }}
              value={type.description}
              checked={pixKeyType === type.description}
              control={<Radio />}
              label={type.description}
              onChange={(e) => setPixKeyType(e.target.value)}
            />
          ))}
          <Box style={{ display: "grid", gap: "6px" }}>
            {pixKeyType !== "" && (
              <>
                <TextField
                  type="text"
                  label="nome do recebedor"
                  size="small"
                  variant="outlined"
                  value={pixName}
                  onChange={(e) => handleChangeName(e)}
                />
                <InputWithMaskara
                  onChange={(e) => handleChange(e)}
                  typesPix={pixKeyType}
                  change={pixKeyValue}
                />
              </>
            )}
          </Box>
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleSavePix}
          >
            Concluir
          </Button>
          <Button color="inherit" onClick={handleCloseDialogPix}>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Payments;
